import ReactDOM from 'react-dom';
import ContactForm from "./src/index";
import React from 'react';

if (document.getElementById("contact-form-root")) {
  ReactDOM.render(
    <ContactForm />,
    document.getElementById("contact-form-root")
  );
}